import { instance } from '../lib/api'
import Constants from '../utils/CommonConstants'
import { API_FAIL } from './dashboard'
import { LOAD_COUNT_INCREMENT, LOAD_COUNT_DECREMENT } from './loading'

export const UPDATE_INVOICE_MONTH = 'UPDATE_INVOICE_MONTH'

const getSetInvoiceMonth = (dispatch, method) => {
  dispatch({
    type: LOAD_COUNT_INCREMENT
  })
  return instance({
    url: '/sapna/v1/master-attribute/rcm-month',
    method
  })
    .then(
      resp => {
        dispatch({
          type: UPDATE_INVOICE_MONTH,
          month: resp.data.data
        })
      },
      err => {
        dispatch({
          type: API_FAIL
        })
      }
    )
    .finally(() => {
      dispatch({
        type: LOAD_COUNT_DECREMENT
      })
    })
}

export const getInvoiceMonth = () => {
  return dispatch => getSetInvoiceMonth(dispatch, 'GET')
}

export const resetInvoiceMonth = () => {
  return dispatch => getSetInvoiceMonth(dispatch, 'PUT')
}



/** WEBPACK FOOTER **
 ** ./src/actions/invoiceMonth.js
 **/